import { useEffect, useState } from 'react';
import Player from '../Players/Player';
import Cart from '../Cart/Cart';
import './Home.css';


const Home = () => {
  
  const [players,setPlayers] =useState([]);
  const [cart,setCart]=useState([]);
  const handleAddPlayers = (player) =>{
    
      
    const newCart=[...cart, player];
    setCart(newCart);

    

  }
  useEffect(()=> {
    fetch('https://www.json-generator.com/api/json/get/bVutsjivJu?indent=2')
    .then(res =>res.json())
    .then(data=> setPlayers(data))
   
  },[])
    return (
        <div className="home-container">
           <div className="players-container">
            {
           players.map(player => <Player 
            handleAddPlayers ={handleAddPlayers}
            player={player} ></Player> )
          }
          </div> 
          <div className="select-player">
            
          <Cart  cart={cart}></Cart>
          </div>
           
            
        </div>
    );
};

export default Home;
